// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NavItem_navItem__BdTzC {
	padding: 5px;
	display: inline-block;
	cursor: pointer;
	color: var(--black) !important;
	font-weight: 500;
	transition: all 0.3s;
	background-color: var(--white);
	border: 2px solid var(--lemon);
	border-radius: 5px;
}

.NavItem_focused__ZoWGX {
	background-color: var(--lemon) !important;
	color: var(--white) !important;
}

.NavItem_focused__ZoWGX:hover {
	box-shadow: 0 0 3px 2px var(--lemon);
}

.NavItem_navItem__BdTzC:not(.NavItem_focused__ZoWGX):hover {
	background-color: var(--lemon) !important;
	color: var(--white) !important;
}

.NavItem_faWallet__Nbpx6 {
	transition: color 0.5s !important;
}

.NavItem_navItem__BdTzC .NavItem_faWallet__Nbpx6 {
	color: var(--lemon) !important;
}

.NavItem_faWallet_icon__u9FUO {
	color: var(--lemon) !important;
	font-size: 30px;
	transition: color 0.5s !important;
}

.NavItem_navItem__BdTzC:not(.NavItem_focused__ZoWGX):hover .NavItem_faWallet__Nbpx6,
.NavItem_navItem__BdTzC:not(.NavItem_focused__ZoWGX):hover .NavItem_faWallet_icon__u9FUO {
	color: var(--blue) !important;
}

.NavItem_focused__ZoWGX .NavItem_faWallet__Nbpx6,
.NavItem_focused__ZoWGX .NavItem_faWallet_icon__u9FUO {
	color: var(--blue) !important;
}

.NavItem_grayed__iOp2T {
	color: gray !important;
	border: none !important;
}

.NavItem_grayed__iOp2T:hover {
	box-shadow: none !important;
	cursor: default !important;
}

@media only screen and (max-width: 900px) and (min-width: 761px) {
}

@media only screen and (max-width: 760px) {
	.NavItem_navItem__BdTzC {
		border: none;
		border-bottom: 1px solid var(--lemon);
		width: 170px !important;
	}
}

@media only screen and (max-width: 760px) and (min-width: 481px) {
}

@media only screen and (max-width: 480px) and (min-width: 361px) {
}

@media only screen and (max-width: 360px) {
}
`, "",{"version":3,"sources":["webpack://./src/styles/NavItem.module.css"],"names":[],"mappings":"AAAA;CACC,YAAY;CACZ,qBAAqB;CACrB,eAAe;CACf,8BAA8B;CAC9B,gBAAgB;CAChB,oBAAoB;CACpB,8BAA8B;CAC9B,8BAA8B;CAC9B,kBAAkB;AACnB;;AAEA;CACC,yCAAyC;CACzC,8BAA8B;AAC/B;;AAEA;CACC,oCAAoC;AACrC;;AAEA;CACC,yCAAyC;CACzC,8BAA8B;AAC/B;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;CAC9B,eAAe;CACf,iCAAiC;AAClC;;AAEA;;CAEC,6BAA6B;AAC9B;;AAEA;;CAEC,6BAA6B;AAC9B;;AAEA;CACC,sBAAsB;CACtB,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;CAC3B,0BAA0B;AAC3B;;AAEA;AACA;;AAEA;CACC;EACC,YAAY;EACZ,qCAAqC;EACrC,uBAAuB;CACxB;AACD;;AAEA;AACA;;AAEA;AACA;;AAEA;AACA","sourcesContent":[".navItem {\n\tpadding: 5px;\n\tdisplay: inline-block;\n\tcursor: pointer;\n\tcolor: var(--black) !important;\n\tfont-weight: 500;\n\ttransition: all 0.3s;\n\tbackground-color: var(--white);\n\tborder: 2px solid var(--lemon);\n\tborder-radius: 5px;\n}\n\n.focused {\n\tbackground-color: var(--lemon) !important;\n\tcolor: var(--white) !important;\n}\n\n.focused:hover {\n\tbox-shadow: 0 0 3px 2px var(--lemon);\n}\n\n.navItem:not(.focused):hover {\n\tbackground-color: var(--lemon) !important;\n\tcolor: var(--white) !important;\n}\n\n.faWallet {\n\ttransition: color 0.5s !important;\n}\n\n.navItem .faWallet {\n\tcolor: var(--lemon) !important;\n}\n\n.faWallet_icon {\n\tcolor: var(--lemon) !important;\n\tfont-size: 30px;\n\ttransition: color 0.5s !important;\n}\n\n.navItem:not(.focused):hover .faWallet,\n.navItem:not(.focused):hover .faWallet_icon {\n\tcolor: var(--blue) !important;\n}\n\n.focused .faWallet,\n.focused .faWallet_icon {\n\tcolor: var(--blue) !important;\n}\n\n.grayed {\n\tcolor: gray !important;\n\tborder: none !important;\n}\n\n.grayed:hover {\n\tbox-shadow: none !important;\n\tcursor: default !important;\n}\n\n@media only screen and (max-width: 900px) and (min-width: 761px) {\n}\n\n@media only screen and (max-width: 760px) {\n\t.navItem {\n\t\tborder: none;\n\t\tborder-bottom: 1px solid var(--lemon);\n\t\twidth: 170px !important;\n\t}\n}\n\n@media only screen and (max-width: 760px) and (min-width: 481px) {\n}\n\n@media only screen and (max-width: 480px) and (min-width: 361px) {\n}\n\n@media only screen and (max-width: 360px) {\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"navItem": `NavItem_navItem__BdTzC`,
	"focused": `NavItem_focused__ZoWGX`,
	"faWallet": `NavItem_faWallet__Nbpx6`,
	"faWallet_icon": `NavItem_faWallet_icon__u9FUO`,
	"grayed": `NavItem_grayed__iOp2T`
};
export default ___CSS_LOADER_EXPORT___;
